var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpBooksApiV5Request } from './http-api-request.js';
export function requestBookAccess(bookId, permission, message, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let request = new HttpBooksApiV5Request(`${bookId}/collaborators/request`, config)
            .setMethod('POST')
            .addParam('permission', permission);
        if (message) {
            request = request.addParam('message', message);
        }
        yield request.fetch();
    });
}
export function resolveBookAccessRequest(bookId, accessRequestId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield new HttpBooksApiV5Request(`${bookId}/collaborators/request/${encodeURIComponent(accessRequestId)}`, config)
            .setMethod('GET')
            .fetch();
        return response.data;
    });
}
export function listCollaborators(bookId, config) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const response = yield new HttpBooksApiV5Request(`${bookId}/collaborators`, config)
            .setMethod('GET')
            .fetch();
        return ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.items) || [];
    });
}
export function addOrUpdateCollaborator(bookId, collaborator, message, config) {
    return __awaiter(this, void 0, void 0, function* () {
        let request = new HttpBooksApiV5Request(`${bookId}/collaborators`, config)
            .setMethod('POST')
            .setPayload(collaborator);
        if (message) {
            request = request.addParam('message', message);
        }
        const response = yield request.fetch();
        return response.data;
    });
}
export function removeCollaborator(bookId, email, config) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield new HttpBooksApiV5Request(`${bookId}/collaborators/${email}`, config)
            .setMethod('DELETE')
            .fetch();
        return response.data;
    });
}
//# sourceMappingURL=collaborator-service.js.map